// ======================================================================
// File: incomingQualityService.js
// Module: PPE → Quality → Incoming QA
// Purpose: API communication layer for Incoming Quality Inspection
// Pattern: SAME as fmsService.js (Enterprise Standard)
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

// ----------------------------------------------------------------------
// BASE URL (must match backend blueprint exactly)
// ----------------------------------------------------------------------
const BASE_URL = "/api/ppe/material-flow/incoming-quality";

const incomingQualityService = {

  // ==============================================================
  // LIST INSPECTIONS
  // GET /incoming-quality
  // ==============================================================
  getInspectionList: async (params = {}) => {
    const res = await axiosClient.get(`${BASE_URL}`, {
      params
    });
    return res.data;
  },

  // ==============================================================
  // GET INSPECTION DETAIL
  // GET /incoming-quality/{inspection_id}
  // ==============================================================
  getInspectionById: async (inspectionId) => {
    const res = await axiosClient.get(
      `${BASE_URL}/${inspectionId}`
    );
    return res.data;
  },

  // ==============================================================
  // START INSPECTION
  // POST /incoming-quality/{inspection_id}/start
  // ==============================================================
  startInspection: async (inspectionId) => {
    const res = await axiosClient.post(
      `${BASE_URL}/${inspectionId}/start`
    );
    return res.data;
  },

  // ==============================================================
  // SAVE PARAMETER READING
  // POST /incoming-quality/save-reading
  // ==============================================================
  saveParameterReading: async (payload) => {
    /*
      Expected payload example:
      {
        inspection_line_id,
        parameter_id,
        observed_value,
        accepted_qty,
        rejected_qty,
        remarks
      }
    */
    const res = await axiosClient.post(
      `${BASE_URL}/save-reading`,
      payload
    );
    return res.data;
  },

  // ==============================================================
  // COMPLETE INSPECTION
  // POST /incoming-quality/{inspection_id}/complete
  // ==============================================================
  completeInspection: async (inspectionId) => {
    const res = await axiosClient.post(
      `${BASE_URL}/${inspectionId}/complete`
    );
    return res.data;
  }

};

export default incomingQualityService;